import { gems } from "./apiBase";

const storeApi = {
  payment: {
    info: gems("POST store/payment/info")
  },
  backup: gems("POST store/backup"),
  order: {
    pay: gems("POST store/pay"),
    save: gems("POST store/save"),
    preview: gems("POST store/preview"),
    calculate: gems("POST store/calculate"),
    list: gems("POST store/list"),
    detail: gems("GET store/detail/{id}"),
    latest: gems("POST store/latest/{userAccount}"),
    // change order's customer
    change: gems("POST store/change"),
    receipt: gems("GET store/receipt-info-pdf/{type}/{pageFormat}/{orderNo}")
  }
};
export default storeApi;
